import React from 'react';
import DataTableWithForm from '../components/DataTableWithForm';

const ProductSetup = () => {
  return (
    <DataTableWithForm
      title="Product Setup"
      fetchUrl="/zts/admin/v1.0/product/"
      createUrl="/zts/admin/v1.0/product/"
      updateUrl={(id) => `/zts/admin/v1.0/product/${id}/`}
      deleteUrl={(id) => `/zts/admin/v1.0/product/${id}/`}
      columns={[
        { field: 'code', label: 'Code' },
        { field: 'name', label: 'Name' },
        { field: 'inventory_quantity', label: 'Inventory' },
        {
          field: 'image_url',
          label: 'Image',
          format: (val) => val ? <img src={val} alt="Product" style={{ width: 50, height: 50, objectFit: 'cover' }} /> : 'No image'
        },
        { field: 'is_active', label: 'Active', format: (val) => (val ? 'Yes' : 'No') },
      ]}
      formFields={[
        { name: 'code', label: 'Code' },
        { name: 'name', label: 'Name' },
        { name: 'inventory_quantity', label: 'Inventory Quantity' },
        { name: 'image_url', label: 'Image URL' },
        { name: 'is_active', label: 'Is Active (true/false)' },
      ]}
    />
  );
};

export default ProductSetup;
